 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import ACOVER from '@/components/1-cover'
 import EBADFRONT from '@/components/ebadfront'
 import ADD2019FRONTADD from '@/components/Add-2019/Front-add'
 import LOVE_1 from '@/components/love_1'
 import ATITLE_PAGE from '@/components/2-title_page'
 import ADEDICATION from '@/components/3-dedication'
 import AEPIGRAPH from '@/components/4-epigraph'
 import ATOC from '@/components/5-TOC'
 import ASTART from '@/components/6-start'
 import APROLOGUE from '@/components/7-prologue'
 import ATHEBUTTERFLY from '@/components/8-thebutterfly'
 import ASUNNY511 from '@/components/9-sunny511'
 import A0REVOLUTION from '@/components/10-revolution'
 import A1SUNNY569 from '@/components/11-sunny569'
 import A2LIFEUPDOWN from '@/components/12-lifeupdown'
 import A3SUNNY649 from '@/components/13-sunny649'
 import A4AGEOMETRY from '@/components/14-ageometry'
 import A5SUNNY709 from '@/components/15-sunny709'
 import A6STRANGE from '@/components/16-strange'
 import A7SUNNY790 from '@/components/17-sunny790'
 import A8UNIVERSALITY from '@/components/18-universality'
 import A9SUNNY868 from '@/components/19-sunny868'
 import A0THEEXPERIMENT from '@/components/20-theexperiment'
 import A1SUNNY922 from '@/components/21-sunny922'
 import A2IMAGES from '@/components/22-images'
 import A3SUNNY977 from '@/components/23-sunny977'
 import A4THEDYNAMICAL from '@/components/24-thedynamical'
 import A5SUNNY1031 from '@/components/25-sunny1031'
 import A6INNERRHYTHMS from '@/components/26-innerrhythms'
 import A7SUNNY1117 from '@/components/27-sunny1117'
 import A8CHAOS from '@/components/28-chaos'
 import A9PAGE303 from '@/components/29-page303'
 import LOVE_2 from '@/components/love_2'
 import A0AFTERWORD from '@/components/30-afterword'
 import A1NOTES from '@/components/31-notes'
 import A2ACKNOWLEDGMENTS from '@/components/32-acknowledgments'
 import A3INDEX from '@/components/33-index'
 import A4COPYRIGHT from '@/components/34-copyright'
 import EBADBACK from '@/components/ebadback'
 import AUBA from '@/components/auba'
 import ORIMAD from '@/components/ORIMad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/5-TOC",
 			"name" : "5-TOC",
 			"component" : ATOC
 		},
 		{
 			"path" : "/6-start",
 			"name" : "6-start",
 			"component" : ASTART
 		},
 		{
 			"path" : "/7-prologue",
 			"name" : "7-prologue",
 			"component" : APROLOGUE
 		},
 		{
 			"path" : "/8-thebutterfly",
 			"name" : "8-thebutterfly",
 			"component" : ATHEBUTTERFLY
 		},
 		{
 			"path" : "/9-sunny511",
 			"name" : "9-sunny511",
 			"component" : ASUNNY511
 		},
 		{
 			"path" : "/10-revolution",
 			"name" : "10-revolution",
 			"component" : A0REVOLUTION
 		},
 		{
 			"path" : "/11-sunny569",
 			"name" : "11-sunny569",
 			"component" : A1SUNNY569
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js